/** Highlighter stroke under the key phrase, like a marked-up newspaper line. */
export const gtmMarker = (
  <span className="bg-[linear-gradient(to_top,var(--marker)_42%,transparent_42%)] box-decoration-clone px-1" />
)
